import { Routes as AppRoutes } from "@/constants/routes";

const NYSC_DOMAIN = "newyorksportsclubs.zing-gym.coach";

export const isNyscDomain = () => window.location.hostname === NYSC_DOMAIN;

export const isNyscPathOrDomain = () =>
    isNyscDomain() || window.location.pathname.includes(AppRoutes.Nysc);

export const getNyscBasePath = () => (isNyscDomain() ? "" : `/${AppRoutes.Nysc}`);
